import api from '../api/client';

const getAll = async (appId, includeInactive = false) => {
    if (!appId) throw new Error('App ID is required');
    const res = await api.get(`/api/tenant/get-all-tenants`, {
        params: { app_id: appId, include_inactive: includeInactive },
    });
    return res?.data?.data;
};

// Server-paged list for the Tenants data table. `query` = { page, limit, sort, dir, search, filter_* }.
// Includes inactive tenants so they can be re-activated; the table's status filter narrows it.
const getPage = async (appId, query) => {
    if (!appId) throw new Error('App ID is required');
    const res = await api.get(`/api/tenant/get-all-tenants`, {
        params: { app_id: appId, include_inactive: true, ...query },
    });
    return res?.data?.data;
};

const getByName = async (tenantName, appId) => {
    if (!tenantName || !appId) throw new Error('Tenant name and App ID are required');
    const res = await api.get(`/api/tenant/get-tenant/${encodeURIComponent(tenantName)}`, {
        params: { app_id: appId },
    });
    return res?.data?.data;
};

const create = async (payload) => {
    const res = await api.post('/api/tenant/create-tenant', payload);
    return res?.data;
};

const updateConfig = async (tenantId, tenantConfig) => {
    const res = await api.post('/api/tenant/update-tenant-config', {
        tenant_id: tenantId,
        tenant_config: tenantConfig,
    });
    return res?.data;
};

const updateStatus = async (tenantId, isActive) => {
    const res = await api.post('/api/tenant/update-tenant-status', {
        tenant_id: tenantId,
        is_active: isActive,
    });
    return res?.data;
};

const deleteTenant = async (tenantId) => {
    const res = await api.delete('/api/tenant/delete-tenant', {
        data: { tenant_id: tenantId },
    });
    return res?.data;
};

// Public (pre-auth): minimal [{ tenant_id, tenant_name }] for an app's login dropdown.
const getPublicList = async (appId) => {
    if (!appId) return [];
    const res = await api.get('/api/tenant/public-list', { params: { app_id: appId } });
    return res?.data?.data || [];
};

const tenantsService = {
    getAll,
    getPage,
    getByName,
    create,
    updateConfig,
    updateStatus,
    deleteTenant,
    getPublicList,
};

export default tenantsService;
